import React, { Component } from 'react';
import Cropper from 'cropperjs';
import PropTypes from 'prop-types';

class CropperCanvas extends Component {
  constructor(props) {
    super(props);
    this.img = React.createRef();
  }

  componentDidMount() {
    const options = {
      // load crop frame on image load
      autoCrop: true,

      // default crop frame covers entire image (100%)
      autoCropArea: 1.0,

      // Don't allow cropping of images we don't host (we rely on CORS
      // headers being set)
      checkCrossOrigin: true,

      aspectRatio: this.props.aspectRatio,
      movable: false,
      zoomable: false
    };

    this.cropper = new Cropper(this.img.current, options);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.rotation !== this.props.rotation) {
      this.cropper.rotateTo(this.props.rotation);
    }

    if (prevProps.aspectRatio !== this.props.aspectRatio) {
      this.cropper.setAspectRatio(this.props.aspectRatio);
    }
  }

  getCroppedCanvas(options) {
    return this.cropper.getCroppedCanvas(options);
  }

  render() {
    return (
      <div className="cropper-container" style={{ width: '75%', maxHeight: '50vh' }}>
        <img
          alt=""
          style={{ maxWidth: '100%' }}
          src={this.props.imageSrc}
          ref={this.img}
        />
      </div>
    );
  }
}

CropperCanvas.propTypes = {
  aspectRatio: PropTypes.number.isRequired,
  imageSrc: PropTypes.string,
  rotation: PropTypes.number.isRequired
};

CropperCanvas.defaultProps = {
  imageSrc: null
};

export default CropperCanvas;
